import { useState } from 'react';

// Blur-up image component — shows a tiny blurred LQIP thumbnail instantly,
// then fades in the full image once it finishes downloading.
// Falls back to a grey skeleton if no lqip is provided.
export default function FadeImage({ src, alt, className, skeletonClass = 'bg-[#DDD5C8]', lqip }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative w-full h-full overflow-hidden">
      {!loaded && (
        lqip ? (
          // LQIP: scale-110 hides the blur-filter soft edges
          <img
            src={lqip}
            aria-hidden
            alt=""
            className="absolute inset-0 w-full h-full object-cover scale-110"
            style={{ filter: 'blur(12px)' }}
          />
        ) : (
          <div className={`absolute inset-0 animate-pulse ${skeletonClass}`} />
        )
      )}
      <img
        src={src}
        alt={alt}
        className={`${className} transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
